<po-widget
  *ngIf="vulnerability?.aliases?.length"
  class="po-p-0"
  p-title="Aliases"
  class="widget"
>
  <div class="po-row">
    <div *ngFor="let alias of vulnerability.aliases">
      <po-tag
        *ngIf="alias.vulnDbId"
        p-orientation="vertical"
        [p-value]="alias.vulnDbId"
      />

      <po-tag
        class="po-ml-1"
        *ngIf="alias.ghsaId"
        p-orientation="vertical"
        [p-value]="alias.ghsaId"
      />
    </div>
  </div>
</po-widget>

<br />

<div class="po-p-0 po-m-0" style="position: relative">
  <po-widget
    class="widget po-p-0"
    p-title="Descrição"
    [p-primary-label]="aiAnalysisLabel"
    (p-primary-action)="aiAnalysis(vulnerability)"
    [p-disabled]="analysing"
  >
    <div *ngIf="vulnerability?.title">
      <h1 [innerHTML]="vulnerability.title"></h1>

      <br />
    </div>

    <p
      *ngIf="analysis || vulnerability?.description"
      [innerHTML]="analysis || vulnerability?.description | markdownParser"
    ></p>
  </po-widget>

  <po-loading-overlay *ngIf="analysing" p-size="xs" p-text="Analisando" />
</div>
